import { connect } from 'react-redux';
import { fetchUsers, selectUser } from '../../actions/users_actions';

import Users from '../../components/Users/users'


function mapStateToProps(state) {
    return {
        users: state.users.all,
        currentUser: state.users.currentUser,
        isLoading: state.users.isLoading,
        error: state.users.error
    };
}

export default connect(mapStateToProps, { fetchUsers, selectUser })(Users);


// WEBPACK FOOTER //
// ./master/jsx/containers/Users/users.jsx